import { Modal } from 'bootstrap';

import { createImageStore } from '../../../../images/lib';
import { useQueryClient } from '@tanstack/react-query';

import ImageWizard from '../../../../images/ImageWizard';

export default function ImageUploadModal({ id, onChange }) {
  const modalId = `imageUpload-${id}-Modal`;

  const queryClient = useQueryClient();

  const imageStore = createImageStore();

  const handleSave = (resImg) => {
    // Programatically close the modal
    const modal = document.getElementById(modalId);
    if (modal) {
      const bsModal = Modal.getInstance(modal) || new Modal(modal);
      bsModal.hide();
    }

    queryClient.invalidateQueries({ queryKey: ['builderWrapper', 'images'] }); // Invalidate the query to refresh images

    onChange({ id: resImg.id, url: resImg.url, alt: '', title: '' });
  };

  return (
    <div className="modal fade" id={modalId} tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex w-100 justify-content-between align-items-center">
              <h1 className="modal-title fs-3">Upload an image</h1>
              <button type="button" className="btn btn-sm btn-danger" data-bs-dismiss="modal" aria-label="Close">
                <i className="fe fe-x" />
              </button>
            </div>
          </div>
          <div className="modal-body">
            <ImageWizard imageStore={imageStore} handleCallback={handleSave} />
          </div>
        </div>
      </div>
    </div>
  );
}
